function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Text, StyleSheet, Image, TouchableOpacity } from "react-native";

// @ts-ignore
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { facebookImage } from "./assets";
export default class CustomFacebookLogInButton extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/React.createElement(FacebookLogin
    // Customizable Area Start
    , {
      fields: "name,email,picture",
      scope: "email,public_profile"
      // Customizable Area End
      ,
      appId: this.props.appId,
      callback: this.props.callback,
      render: renderProps => /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: () => {
          renderProps.onClick();
          this.props.onPress();
        },
        style: styles.facebookStyle
      }, /*#__PURE__*/React.createElement(Image, {
        style: styles.facebookImageStyle,
        source: facebookImage
      }), /*#__PURE__*/React.createElement(Text, {
        style: styles.facebookTextStyle
      }, this.props.loginFacebookButtonText))
    })
    // Customizable Area End
    ;
  }
}

// Customizable Area Start
_defineProperty(CustomFacebookLogInButton, "propTypes", {
  testID: PropTypes.string,
  appId: PropTypes.string,
  loginFacebookButtonText: PropTypes.string,
  callback: PropTypes.func.isRequired,
  onPress: PropTypes.func.isRequired
  // Customizable Area Start
  // Customizable Area End
});
const styles = StyleSheet.create({
  facebookStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "black",
    shadowOpacity: 0.3,
    elevation: 6,
    shadowRadius: 8,
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: "#ffffff",
    padding: "11px"
  },
  facebookImageStyle: {
    marginRight: 10,
    width: 20,
    height: 20
  },
  facebookTextStyle: {
    color: "#2553b4",
    fontFamily: "Helvetica-Bold, sans-serif",
    paddingLeft: 7
  }
});
// Customizable Area End